import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=86d749aa&scoped=true"
import script from "./coupons.vue?vue&type=script&lang=js"
export * from "./coupons.vue?vue&type=script&lang=js"
import style0 from "./coupons.vue?vue&type=style&index=0&id=86d749aa&prod&lang=scss&scoped=true"
import style1 from "./coupons.vue?vue&type=style&index=1&id=86d749aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d749aa",
  null
  
)

export default component.exports